import { gql } from "@apollo/client";

export const GET_WORK_PROGRESS_DATA = gql`
    query GetWorkProgressData($hubId: ID!, $startTime: String!, $endTime: String!, $channelId: ID, $carrierCode: Int) {
        getWorkProgressData(hubId: $hubId, startTime: $startTime, endTime: $endTime, channelId: $channelId, carrierCode: $carrierCode) {
            accountSummaries {
                accountId
                accountName
                accountPhone
                pickupArrival
                sorting
                bagging
                baggingTask
                departure
            }
            hourlyData {
                hour
                pickupArrival
                sorting
                bagging
                baggingTask
                departure
            }
            statTypes {
                value
                legendKey
            }
        }
    }
`;

export interface AccountSummary {
    accountId: number;
    accountName: string;
    accountPhone: number | null;
    pickupArrival: number;
    sorting: number;
    bagging: number;
    baggingTask: number;
    departure: number;
}

export interface HourlyDataPoint {
    hour: string;
    pickupArrival: number;
    sorting: number;
    bagging: number;
    baggingTask: number;
    departure: number;
}

export interface WarehouseWorkStatTypeInfo {
    value: number;
    legendKey: string;
}

export interface WorkProgressData {
    accountSummaries: AccountSummary[];
    hourlyData: HourlyDataPoint[];
    statTypes: WarehouseWorkStatTypeInfo[];
}

export interface GetWorkProgressDataResponse {
    getWorkProgressData: WorkProgressData;
}

export interface GetWorkProgressDataVariables {
    hubId: string;
    startTime: string;
    endTime: string;
    channelId?: string | null;
    carrierCode?: number | null;
}

